module.exports = __webpack_public_path__ + "static/media/sgsling.e39bc8c6.jpg";